/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLastFlattened_settings = {
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_settings">;
    readonly " $refType": "ReplyListContainerLastFlattened_settings";
};
export type ReplyListContainerLastFlattened_settings$data = ReplyListContainerLastFlattened_settings;
export type ReplyListContainerLastFlattened_settings$key = {
    readonly " $data"?: ReplyListContainerLastFlattened_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLastFlattened_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLastFlattened_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'ccf5622da6165b8df1b7f1594d43f274';
export default node;
